import React from 'react';

const Proceed = () => {
    return (
        <div>
            <div className="text-center">
                <img src={'https://miro.medium.com/max/1080/1*ltnqQzEc5B7INBsCRz5LpA.png'} className="rounded w-50 mx-auto d-block" alt="..." />
            </div>
        </div>
    );
};

export default Proceed;